import { h } from 'preact';
import { map, isNil } from 'lodash';
import classNames from 'classnames';
import { BringgIcon, BringgFontIcons } from '@bringg/bringg-icons';
import poweredByLogo from '../../assets/powered-by-reverse.svg';
import { useTheme } from '../../hooks/use-theme/use-theme';
import { useTranslation } from '../../hooks/use-translation';
import { getIconVisibility } from '../../helpers/aria-helper';
import { LoadingConfig, LoadingSideNavButton, SideNavButton } from './side-nav-button/side-nav-button';

interface Props {
	isOpen: boolean;
	buttonsConfig: ButtonsConfig;
	header: JSX.Element;
	onClose: () => void;
}

export interface ButtonsConfig {
	[key: string]: ButtonConfig;
}

export interface ButtonConfig {
	text: string;
	icon: BringgFontIcons;
	onClick: () => void | Promise<any>;
	loadingConfig?: LoadingConfig;
}

const getButtons = (buttonsConfig: ButtonsConfig) => {
	return map(buttonsConfig, ({ text, icon, onClick, loadingConfig }, key) => {
		if (isNil(loadingConfig)) {
			return <SideNavButton text={text} key={key} icon={icon} onClick={onClick} />;
		} else {
			return (
				<LoadingSideNavButton
					text={text}
					key={key}
					icon={icon}
					onClick={onClick as () => Promise<any>}
					loadingConfig={loadingConfig}
				/>
			);
		}
	});
};

const SideNav = ({ isOpen, buttonsConfig, header, onClose }: Props) => {
	const { t } = useTranslation();
	const { headerColor } = useTheme();

	return (
		<div className="side-nav-container">
			{isOpen && <div className="overlay" onClick={onClose} />}
			<div
				className={classNames('side-nav', { open: isOpen })}
				data-testid="side-nav"
				style={getIconVisibility(isOpen)}
			>
				<div className="side-nav-header item" style={{ backgroundColor: headerColor }}>
					<button
						className={'side-nav-close-icon'}
						aria-label={t('CLOSE_MENU')}
						onClick={onClose}
						tabIndex={0}
					>
						<BringgIcon iconName={BringgFontIcons.Close} aria-hidden={true} />
					</button>
					{header}
				</div>
				<div className="content-wrapper">
					<div className="items">{getButtons(buttonsConfig)}</div>
					<div className="powered-by-logo-item" aria-hidden="true">
						<img className="logo" src={poweredByLogo} alt="powered by bringg" />
					</div>
				</div>
			</div>
		</div>
	);
};

export default SideNav;
